import { ApiPromotions } from 'idt-ecommerce-api/_api/api-promotions/models/api-promotion.models';
import { ApiShippingMethodList } from 'idt-ecommerce-api/_api/api-shipping/models/api-shipping.models';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { PromotionTransformer } from 'idt-ecommerce-api/promotions/promotion.transformer';
import { Promotion } from 'idt-ecommerce-api/promotions/promotions.model';
import { MoneyHelpers } from 'idt-ecommerce-api/util/money.helpers';

import { ShippingMethod } from '../models/shipping.model';


export class ShippingTransformer {

  public static getShippingMethodsUniqueFromAPI(
    context: EcommerceContext,
    apiMethods: ApiShippingMethodList,
    apiPromotions?: ApiPromotions
  ): ShippingMethod[] {
    const currencyInfo = context?.store?.details?.currencyInfo;

    const shippingMethods: ShippingMethod[] = apiMethods.shippingMethods.map((shippingsMethod) => {
      const method: ShippingMethod = {
        name: shippingsMethod.name,
        description: shippingsMethod.description,
        price: shippingsMethod.price && currencyInfo ? MoneyHelpers.formatPriceWithCurrencySymbol(shippingsMethod.price, currencyInfo) : '',
        dbcode: shippingsMethod.dbcode
      };

      if (isDefined(apiPromotions)) {
        const promotions = PromotionTransformer.getPromotionsFromApi(apiPromotions.promotions, context);

        const shippingPromotions = promotions.filter((promotion: Promotion) => {
          return promotion.shippingMethods.some((shippingMethod) => shippingMethod === method.dbcode);
        });

        method.promotions = shippingPromotions;
      }

      return method;
    });

    return shippingMethods;
  }

}
